/* Dependencies:
 * $, Cookies, BS modal
 */

;(function($, window, Cookies, undefined){
	"use strict";

	var _moduleId = 'modalWorkwithus';
	var _autoShowTimeout = 1; // seconds, -1 => disable, minimum 2sec advised
	var _cookieLifetime = 2; // days

	function getModal() {
		return $('#'+_moduleId);
	};

	function onShow(){
		// Noop
	}
	function onDismiss(){ // This event can be unintentional
		// Noop
	}
	function onClose(){ // This event is intentional
		if (Cookies) {
			Cookies.set(_moduleId+'-dismissed', true, _cookieLifetime);
		}
		getModal().modal('hide');
	}
	function show(){
		getModal().modal('show');
	}
	function processFirstStep(e){
		e.preventDefault();

		$.post( 
			"https://hooks.zapier.com/hooks/catch/77724/gfhq2x/", 
			getModal().find('[data-modal-form-1]').serialize()
		).done(function(){
			window.location.href = "https://docs.google.com/forms/d/e/1FAIpQLScY423YKfT-j1cq1vPKtY5jlr7L4kCSkPcCQ-JwY673F4tdGg/viewform";
			return false;

			getModal().find('[data-modal-left]').remove();
			getModal().find('#workwithusSteps-2').collapse('toggle');
			getModal().find('[data-modal-right]').removeClass('col-lg-6').addClass('col-12');
		});

	}
	
	function init(){
		// getModal().on('show.bs.modal', onShow);
		// getModal().on('hide.bs.modal', onDismiss);
		getModal().find('[data-modal-close]').on('click', onClose);
		// getModal().find('[data-modal-goto-2]').on('click', processFirstStep);
		getModal().find('[data-modal-form-1]').on('submit', processFirstStep);

		//console.info('getmodal in init', getModal(), getModal().find('[data-modal-close]'))

		if (_autoShowTimeout > -1) {
			setTimeout(show, _autoShowTimeout*1e3);
		}
	};


	if (Cookies && !Cookies.get(_moduleId+'-dismissed')){
		document.addEventListener("DOMContentLoaded", function() {
			init();
		});
	}

})(jQuery, window, Cookies);